import React, { useEffect, useMemo } from 'react';

const resolveAdminUrl = (): string => {
  const configured = import.meta.env.VITE_ADMIN_ORIGIN?.trim();
  if (configured) return configured.replace(/\/$/, '');

  const { protocol, hostname, port } = window.location;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `${protocol}//${hostname}${port ? `:${port}` : ''}/admin`;
  }

  const siteHostname = hostname.replace(/^www\./, '').replace(/^may\./, '');
  return `${protocol}//may.${siteHostname}`;
};

const AdminRedirect: React.FC = () => {
  const adminUrl = useMemo(resolveAdminUrl, []);

  useEffect(() => {
    window.location.replace(adminUrl);
  }, [adminUrl]);

  return (
    <main className="flex min-h-screen items-center justify-center bg-slate-950 px-6 text-white">
      <div className="max-w-lg text-center">
        <h1 className="text-2xl font-black">Redirection vers l’administration</h1>
        <p className="mt-3 text-slate-300">L’administration Mobilbo s’exécute dans son application sécurisée séparée.</p>
        <a className="mt-6 inline-flex rounded-xl bg-blue-500 px-5 py-3 font-bold text-white" href={adminUrl}>
          Ouvrir l’administration
        </a>
      </div>
    </main>
  );
};

export default AdminRedirect;
